// #region imports

// --- Angular
import { Component, Output, EventEmitter, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-respondent-reminder',
  templateUrl: './respondent-reminder.component.html',
  styleUrls: ['./respondent-reminder.component.scss']
})
export class RespondentReminderComponent {

  @Input() numberOfAllowed: number | null = null;
  @Input() numberOfRespondents: number | null = null;

  @Output() manageGroups = new EventEmitter();
  @Output() closeReminder = new EventEmitter();

  onCloseReminder() {
    this.closeReminder.emit();
  }

  onManageGroups() {
    this.manageGroups.emit();
  }
}
